import {
  SIDEBAR_CLOSED_WIDTH,
  SIDEBAR_OPEN_WIDTH,
} from '#app/constants/sidenav.js';
import { css, styled } from 'styled-components';

export const NavbarSpacer = styled.div<{ open?: boolean }>`
  ${({ open, theme }) => css`
    transition: width 200ms cubic-bezier(0.4, 0.9, 0.2, 1) 0ms;
    display: block;
    will-change: width;
    ${theme.mediaQueries.lg} {
      width: ${open ? SIDEBAR_OPEN_WIDTH : SIDEBAR_CLOSED_WIDTH}px;
    }
  `}
`;
